@file:Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")

package io

import androidx.compose.runtime.*
import api.*
import common.frontend.api.*
import io.ktor.client.*
import kotlinx.coroutines.flow.*
import provider.*
import tk.mallumo.utils.*
import kotlin.time.*
import kotlin.time.Duration.Companion.minutes
import kotlin.time.Duration.Companion.seconds

object Repository {

    private val actualLang = mutableStateFlowOf<LanguageType>(LanguageType.English)

    val api by lazy {
        RepoApi(actualLang)
    }

    //    val font by lazy {
//        RepoFont(actualLang)
//    }
    val files by lazy {
        RepoFiles(actualLang)
    }

    val strings by lazy {
        RepoStrings(actualLang)
    }

    var serverInfo by mutableStateOf<Io.ServerInfo?>(null)
        private set

    @Composable
    fun setup() {
        val localization = LocalLocalization.current
        LaunchedEffect(localization.language) {
            actualLang.value = localization.language
        }

        LaunchedEffect(Unit) {
            serverInfo = api.server.info()
        }
    }

}

abstract class ImplRepo(val language: StateFlow<LanguageType>) {
    val client = KtorClient()
}

expect open class KtorClient() {
    fun proto(name: String, pass: String): HttpClient
    fun json(name: String? = null, pass: String? = null, timeout: Duration = 30.seconds): HttpClient
    fun raw(name: String, pass: String, timeout: Duration = 1.minutes): HttpClient
    fun rawCached(name: String, pass: String): HttpClient
    fun rawCached(): HttpClient
    fun raw(): HttpClient
    fun ws(): HttpClient
}
